import { render, staticRenderFns } from "./FbFile.vue?vue&type=template&id=eaddd448&scoped=true"
import script from "./FbFile.vue?vue&type=script&lang=js"
export * from "./FbFile.vue?vue&type=script&lang=js"
import style0 from "./FbFile.vue?vue&type=style&index=0&id=eaddd448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaddd448",
  null
  
)

export default component.exports